/** 访问页面统计 */
import './index.scss'
import React from 'react';
import { message, Select, Input, Button,DatePicker } from 'antd';
import ComTable from './components/ComTable'
import moment from "moment";
// import DateTimePicker from "../../components/DateTimePicker";
import IconFont from '../../components/IconFont/index';
import api from "../../lib/api";

const { Option } = Select;
const { RangePicker } = DatePicker;
class header extends React.Component {
  isPageSizeChange = false;
  state = {
    statisticsType: null,
    quantileTimeList: [],
    startDate: moment().subtract(1, 'months').add(1, 'day').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    page: 1,
    size: 30,
    orders: [],
    tbData: [],
    loading: false,
    showFilterPopup: false,
    filterData: {
      url: '',
      minCount: null,
      maxCount: null,
      minLoadTime: null,
      maxLoadTime: null
    },
    filterDataClone: {},
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  UNSAFE_componentWillMount = () => {
    this.getStatisticsType();
  };
  // 分位时长 数据
  getStatisticsType() {
    api.getStatisticsType().then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          statisticsType: res.data[0].code,
          quantileTimeList: res.data
        }, () => {
          this.getVisitInfo();
        });
        // 存进 store
        this.props.dispatch({
          type: "quantileTimeList",
          data: res.data
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // 表格数据
  getVisitInfo() {
    const { startDate, endDate, page, size, orders, statisticsType,filterData } = this.state;
    this.setState({ loading: true });
    const params = {
      statisticsType,
      startDate,
      endDate,
      page,
      size,
      orders,
      ...filterData
    };
    api.getVisitInfo(params).then(res => {
      this.setState({ loading: false });
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // 日期范围 三个月以内
  disabledDate = (current) => {
    return current && (current < moment().subtract(3, 'months') || current > moment().endOf('day'));
  };
  // 日期选择
  dateChange = (date, dateString) => {
    this.setState({
      startDate: dateString[0],
      endDate: dateString[1]
    }, () => {
      this.getVisitInfo();
    });
  };
  // 条数改变
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      page: 1,
      size
    }, () => {
      this.getVisitInfo();
    });
  };
  // 页数改变 以及 排序
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    let page = extra.action === 'sort' ? 1 : pagination.current;
    let orders = [];
    if (sorter.order) {
      orders = [{
        field: sorter.field,
        direct: sorter.order === "ascend" ? "ASC" : "DESC"
      }]
    }
    this.setState({
      orders,
      page,
      pagination: Object.assign(this.state.pagination, { current: page, pageSize: pagination.pageSize }),
      size: pagination.pageSize
    }, () => {
      this.getVisitInfo();
    });
  };
  // 下拉选择
  handleChange(key, val) {
    const obj = {};
    obj[key] = val;
    this.setState(obj, () => {
      this.getVisitInfo();
    });
  };
  /** 显示/隐藏筛选弹窗 */
  handleShowFilter(bol) {
    bol ? this.setState({
      filterDataClone: JSON.parse(JSON.stringify(this.state.filterData))
    }) : this.setState({
      filterData: JSON.parse(JSON.stringify(this.state.filterDataClone))
    })
    this.setState({
      showFilterPopup: bol
    })
  };
  /** 更改筛选数据 */
  handleFilterChange(key, val) {
    let obj = this.state.filterData;
    obj[key] = val.target.value;
    this.setState({filterData:obj});
  };
  /** 确定筛选 */
  handleConfirmFilter(){
    this.getVisitInfo();
    this.setState({
      showFilterPopup: false
    })
  };
  render() {
    const { history } = this.props;
    const {statisticsType, quantileTimeList, startDate, endDate, loading, tbData, pagination,showFilterPopup,filterData} = this.state;
    return (
      <div className='page-home'>
        <div className='card'>
          <div className="page-top-filter">
            <IconFont type="icon-shaixuantiaojian" style={{ fontSize: 26 }} className="filter-icon" onClick={() => this.handleShowFilter(true)} />
            <div> 
              <RangePicker disabledDate={this.disabledDate} defaultValue={[moment(startDate), moment(endDate)]} onChange={this.dateChange} />
              <Select value={statisticsType} style={{ width: 160 }} onChange={val => this.handleChange('statisticsType', val)}>
                {quantileTimeList.map(item => {
                  return <Option key={item.code} value={item.code}>{item.name}</Option>
                })}
              </Select>
            </div>
          </div>
          <ComTable
            filterData={{statisticsType, startDate, endDate}}
            history={history} loading={loading} tbData={tbData}
            pagination={pagination} pageChange={this.pageChange} />
        </div>
        <div className='page-tips'>时间单位：毫秒（ms）</div>
        {/** 筛选弹窗 */}
        {showFilterPopup ? <div className="filter-popup">
          <div className="popup-shadow"></div>
          <div className="filter-module">
            <div className="filter-input">
              <div>
                <p>URL</p>
                <Input allowClear={true} value={filterData.url} onChange={val => this.handleFilterChange('url', val)} />
              </div>
              <div className="double-input">
                <p>调用次数</p>
                <Input value={filterData.minCount} onChange={val => this.handleFilterChange('minCount', val)} />
                <span>-</span>
                <Input value={filterData.maxCount} onChange={val => this.handleFilterChange('maxCount', val)} />
              </div>
              <div className="double-input">
                <p>页面加载时间</p>
                <Input value={filterData.minLoadTime} onChange={val => this.handleFilterChange('minLoadTime', val)} />
                <span>-</span>
                <Input value={filterData.maxLoadTime} onChange={val => this.handleFilterChange('maxLoadTime', val)} />
              </div>
            </div>
            <p>
              <Button type="primary" onClick={() => this.handleConfirmFilter()} >确定</Button>
              <Button onClick={() => this.handleShowFilter(false)} >取消</Button>
            </p>
          </div>
        </div> : ''}
      </div>
    );
  }
};

export default header;
